import { render, staticRenderFns } from "./ProductAddListIframe.vue?vue&type=template&id=d9d81f02&"
import script from "./ProductAddListIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductAddListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports